import {
  ConfigBrightcove,
  ConfigGAM,
  ConfigLotame,
  ConfigVWO,
} from "@pub/config";

export const LOTAME_CONFIG: Omit<ConfigLotame, "active"> = {
  clientId: "12374",
};

export const BRIGHTCOVE_CONFIG: ConfigBrightcove = {
  accountId: "4802324438001",
  bgLoopPlayerId: "O0VJjcpnk",
};

export const DEFAULT_CONFIG_GAM: Omit<ConfigGAM, "account"> = {
  prestitialLimit: 3,
  prestitialFrequency: 1,
  catfishFrequency: 4,
  paragraphInsertPos: 3,
  paragraphInsertMax: 3,
  galleryInsertPos: 2,
  galleryInsertMax: 3,
};

export const LOAD_MORE_TEXT = "Loading more articles";

export const VWO_CONFIG: Omit<ConfigVWO, "active"> = {
  accountId: 786868,
};
